import { LayoutQuickSearchSidebar } from "components/BaseLayout";

export default LayoutQuickSearchSidebar
